import { INewExamQuestion } from "@/@types";
import { create } from "zustand";

interface Option {
  id: string;
  questionId: string;
  description: string;
  isCorrect: boolean;
}

interface QuestionStoreState {
  questions: INewExamQuestion[];
  options: Option[];
  selectedQuestionId: string | null;

  addQuestion: (question: INewExamQuestion) => void;
  updateQuestion: (question: INewExamQuestion) => void;
  removeQuestion: (id: string) => void;
  selectQuestion: (id: string) => void;

  addOption: (option: Option) => void;
  updateOption: (option: Option) => void;
  removeOption: (id: string) => void;
  getOptionsByQuestion: (questionId: string) => Option[];
}

export const useQuestionStore = create<QuestionStoreState>((set, get) => ({
  questions: [],
  options: [],
  selectedQuestionId: null,

  addQuestion: (question) =>
    set((state) => ({
      questions: [...state.questions, question],
    })),
  updateQuestion: (question) =>
    set((state) => ({
      questions: state.questions.map((q) =>
        q.question.id === question.question.id ? question : q
      ),
    })),
  removeQuestion: (id) =>
    set((state) => ({
      questions: state.questions.filter((q) => q.question.id !== id),
      options: state.options.filter((o) => o.questionId !== id),
      selectedQuestionId:
        state.selectedQuestionId === id ? null : state.selectedQuestionId,
    })),
  selectQuestion: (id) => set({ selectedQuestionId: id }),

  addOption: (option) =>
    set((state) => ({
      options: [...state.options, option],
    })),
  updateOption: (option) =>
    set((state) => ({
      options: state.options.map((o) => (o.id === option.id ? option : o)),
    })),
  removeOption: (id) =>
    set((state) => ({
      options: state.options.filter((o) => o.id !== id),
    })),
  getOptionsByQuestion: (questionId) =>
    get().options.filter((o) => o.questionId === questionId),
}));
